/**
 * Base URL for the backend API.
 * - dev: empty (Vite proxies /api → localhost:8080)
 * - staging/production: empty (Firebase Hosting rewrite handles /api/** → Cloud Run)
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

let servoToken: string | null = null;

export function setServoToken(token: string | null): void {
  servoToken = token;
}

export function getServoToken(): string | null {
  return servoToken;
}

/**
 * Fetch wrapper that attaches the Servo JWT (issued by /api/auth/login) as a Bearer.
 * The Firebase ID token is only used during the initial /auth/login exchange — never
 * sent directly to other endpoints.
 */
export async function apiFetch(input: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  if (servoToken && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${servoToken}`);
  }
  if (init.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }
  if (!headers.has('x-servo-source')) {
    headers.set('x-servo-source', 'admin');
  }
  const url = input.startsWith('http') ? input : `${API_BASE_URL}${input}`;
  return fetch(url, { ...init, headers });
}

export async function apiJson<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await apiFetch(path, init);
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`${res.status} ${res.statusText}${text ? `: ${text}` : ''}`);
  }
  return res.json() as Promise<T>;
}
